import { Typography } from "antd";
import { ReactElement } from "react";
import { LoginFormLayout } from "../../../layouts/LoginFormLayout/LoginFormLayout";
import { LinkSaveSearchURLParams } from "../../../utils/HOC/LinkSaveSearchURLParams";

import classes from "./SelectRegistration.module.css";

const { Text, Paragraph } = Typography;

const REGISTRATION_VARIANTS = [
  {
    value: "client",
    description: "Создание заявок на имя своей организации (Юр. лицо или ИП)",
    header: "Клиент",
    navigate: "/registerClient",
  },
  {
    value: "agent",
    description:
      "Создание заявок для сторонних организаций / клиентов (Юр. лицо или ИП)",
    header: "Агент",
    navigate: "/registerAgent",
  },
];

export function SelectRegistration(): ReactElement {
  return (
    <LoginFormLayout
      className={classes.registrationSelect}
      showSupportText={false}
      name={"Регистрация"}
    >
      <Text className={classes.registrationSelect__label}>
        Зарегистрироваться как:
      </Text>

      {REGISTRATION_VARIANTS.map((item) => {
        return (
          <LinkSaveSearchURLParams
            className={`${classes.registrationSelect__link} ${classes.link}`}
            to={item.navigate}
            key={item.navigate}
          >
            <Paragraph style={{ margin: 0 }} className={classes.link__title}>
              {item.header}
            </Paragraph>
            <Paragraph className={classes.link__description}>
              {item.description}
            </Paragraph>
          </LinkSaveSearchURLParams>
        );
      })}
    </LoginFormLayout>
  );
}
